import {SEARCH_DELAY_IN_MS} from '@hconnect/common/consts'
import {useEquipmentNumberSearchQuery} from '@hconnect/common/hooks'
import {EquipmentData} from '@hconnect/common/types'
import {getEquipmentLabel} from '@hconnect/common/utils'
import {useDebounce} from '@react-hook/debounce'
import {FilterSearchAutocomplete, FilterSearchAutocompleteProps} from '@widgets/common-filters'

export const TaskEquipmentSearchFilter = <TName extends string>(
  props: Omit<
    FilterSearchAutocompleteProps<TName, EquipmentData>,
    'options' | 'getOptionLabel' | 'getOptionValue' | 'isOptionEqualToValue' | 'searchTerm'
  > & {
    plantId: string
  }
) => {
  const [debouncedSearchText, setDebouncedSearchTerm] = useDebounce('', SEARCH_DELAY_IN_MS)

  const {data: suggestions = [], isLoading} = useEquipmentNumberSearchQuery(
    {searchTerm: debouncedSearchText, plantId: props.plantId},
    {
      enabled: !!props.plantId,
      select: (data) => data.map((plain) => plain.equipment)
    }
  )

  return (
    <FilterSearchAutocomplete<TName, EquipmentData>
      {...props}
      options={suggestions ?? []}
      getOptionLabel={getEquipmentLabel}
      getOptionValue={(option) => option.id}
      isOptionEqualToValue={(option, value) =>
        option.id === value.id && option.idType === value.idType
      }
      searchTerm={debouncedSearchText}
      onSearchChange={setDebouncedSearchTerm}
      isLoading={isLoading}
    />
  )
}
